export const REFETCH_INTERVAL = 5000;
export const MAX_ERROR_COUNT = 3;
export const INVALID_SESSION_STATUS = [3];
export const INVALID_REQUEST_ACCESS_STATUS = [4, 5, 6, 7];

export const LISTROW_TYPES = {
  SESSION: 'session',
  ENDPOINT: 'endpoint',
  ROLE: 'role',
  ACCOUNT: 'account',
};
